import React from 'react';
import { CheckCircle } from 'lucide-react';
interface BonusCardProps {
  title: string;
  value: string;
  isMain?: boolean;
}
export const BonusCard: React.FC<BonusCardProps> = ({
  title,
  value,
  isMain = false
}) => {
  return <div className={`p-6 rounded-2xl shadow-lg border transition-transform duration-300 hover:-translate-y-1 ${isMain ? 'border-[#FF8C00] bg-[#FFFAF0]' : 'border-gray-100 bg-white'} flex items-start gap-4`} data-id="element-8">
      <CheckCircle className={`w-8 h-8 flex-shrink-0 mt-1 ${isMain ? 'text-[#FF8C00]' : 'text-[#008080]'}`} data-id="element-9" />
      <div data-id="element-10">
        <h4 className="font-bold text-xl text-gray-900 mb-2" data-id="element-11">{title}</h4>
        <p className="text-base font-medium text-gray-500" data-id="element-12">
          Valor normal: <span className="line-through" data-id="element-13">{value}</span>
        </p>
        {isMain && <span className="inline-block mt-2 text-xs font-bold uppercase tracking-wider text-[#FF8C00] bg-orange-100 px-2 py-1 rounded-full" data-id="element-14">
            Programa Principal
          </span>}
      </div>
    </div>;
};